import { SelectionType } from '@convergence/types';
import { valueFromTreeAndPath } from '../util';
import { Select } from '@convergence/components';
import { AnalysisInputProps } from '../types';

export function AnalysisSelectInput(props: AnalysisInputProps<SelectionType>) {
  const value = valueFromTreeAndPath<string>(props.tree, props.propertyPath);

  return (
    <div className="py-2">
      <label className="inline-flex items-center">
        {props.name}
        <Select
          className="ml-2"
          onChange={(e) => {
            props.onChange(props.propertyPath, e.target.value);
          }}
          value={value}
        >
          <option value="">Select an option</option>
          {props.value._options.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </Select>
      </label>
    </div>
  );
}
